<template>
  <va-card title="服务列表">
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="serviceName"
          placeholder="search by name"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend"/>
        </va-input>
      </div>
<!--      <div class="flex xs12 sm6">
        <div class="d-flex justify&#45;&#45;end">
          <va-button color="info" small :to="{ name: 'saveService' }">新增服务</va-button>
        </div>
      </div>-->
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      :totalPages="totalPages"
      @page-selected="listService"
      api-mode
    >
      <template slot="image" slot-scope="props">
        <img :src="props.rowData.imageUrl" class="data-table-server-pagination---avatar" alt="avatar">
      </template>
      <template slot="actions" slot-scope="props">
        <va-button flat small color="gray" icon="fa fa-pencil"
          :to='{path:`updateService/${props.rowData.id}`}'/>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>

import serviceApi from '../../api/service'
import uploadApi from '../../api/upload'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      serviceName: null,
      pageSize: 10,
      totalPages: 1,
      items: [],
      loading: true,
      deleteModal: false,
      updateData: {
        id: 1,
        name: '',
        imageUrl: '',
        image: [],
        description: '',
      },
      messages: ['required field'],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:image',
          width: '60px',
        },
        {
          name: 'name',
          title: '服务名称',
          width: '20%',
        },
        {
          name: 'description',
          title: '描述信息',
          width: '70%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.serviceName || this.serviceName.length < 1) {
        return this.items
      }
      return this.items.filter(item => {
        return item.name.toLowerCase().startsWith(this.serviceName.toLowerCase())
      })
    },
  },
  created () {
    this.listService()
  },
  methods: {
    listService (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      serviceApi.listService(params)
        .then(response => {
          this.items = response.services
          this.loading = false
        })
    },
    confirmUpdateService () {
      serviceApi.updateService(this.updateData.id, {
        name: this.updateData.name,
        imageUrl: this.updateData.imageUrl,
        description: this.updateData.description,
      }).then(response => {
        if (response.success === true) {
          this.listService()
        } else {
        }
      }).catch(error => {
        console.log(error)
      })
    },
    cancelUpdateService () {
      this.updateData = {}
    },
    confirmDeleteService () {
      serviceApi.deleteService(this.updateData.id).then(response => {
        console.log(response)
        if (response.success === true) {
          this.listService()
        }
      })
    },
    cancelDeleteService () {
      this.updateData = {}
    },
    uploadServiceImage () {
      if (this.updateData.image.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.updateData.image[0])
      uploadApi.uploadImage(formData).then(response => {
        this.updateData.imageUrl = response.url
      })
    },
    search: debounce(function (serviceName) {
      this.serviceName = serviceName
    }, 400),
  },
}
</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}

.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}

.va-card-image image {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  min-width: 100%;
  min-height: 100%;
}
</style>
